import { useMemo, useState } from "react";
import { ChevronDown } from "lucide-react";

export default function CategoryRail({ categories, active, onPick }) {
  const { tops, childrenOf } = useMemo(() => {
    const ids = new Set(categories.map((c) => c.category_id));
    // Roots = rows whose parent isn't in the feed (incl. parent_id null).
    const roots = categories.filter((c) => !c.parent_id || !ids.has(c.parent_id));
    const rootIds = new Set(roots.map((c) => c.category_id));
    // Real shopping departments sit one level under the taxonomy root.
    let tops = categories.filter((c) => rootIds.has(c.parent_id));
    if (!tops.length) tops = roots;
    const childrenOf = {};
    categories.forEach((c) => {
      if (!c.parent_id) return;
      (childrenOf[c.parent_id] = childrenOf[c.parent_id] || []).push(c);
    });
    const byName = (a, b) => (a.name || "").localeCompare(b.name || "");
    const bySort = (a, b) =>
      (a.hp_sort ?? 1e9) - (b.hp_sort ?? 1e9) || byName(a, b);
    tops = [...tops].sort(bySort).slice(0, 40);
    Object.values(childrenOf).forEach((l) => l.sort(bySort));
    return { tops, childrenOf };
  }, [categories]);

  const [openId, setOpenId] = useState(null);

  const pickTop = (c) => {
    // Accordion: opening one department closes the others.
    setOpenId(openId === c.category_id ? null : c.category_id);
    onPick(c.category_id);
  };

  return (
    <aside className="hpz-shop__rail" data-testid="plaza-category-rail">
      <h3>Departments</h3>
      <button
        className={`hpz-shop__rail-btn ${!active ? "active" : ""}`}
        onClick={() => { setOpenId(null); onPick(null); }}
        data-testid="plaza-cat-all"
      >All categories</button>
      {tops.map((c) => {
        const kids = childrenOf[c.category_id] || [];
        const open = openId === c.category_id;
        return (
          <div key={c.category_id} className="hpz-rail-item">
            <button
              className={`hpz-shop__rail-btn ${active === c.category_id ? "active" : ""}`}
              onClick={() => pickTop(c)}
              data-testid={`plaza-cat-${c.category_id}`}
            >
              <span>{c.name}</span>
              {kids.length > 0 && (
                <ChevronDown size={14} className={`hpz-rail-chev ${open ? "open" : ""}`} />
              )}
            </button>
            {open && kids.length > 0 && (
              <div className="hpz-rail-subs" data-testid={`plaza-subcats-${c.category_id}`}>
                {kids.map((k) => (
                  <button
                    key={k.category_id}
                    className={`hpz-shop__rail-sub ${active === k.category_id ? "active" : ""}`}
                    onClick={() => onPick(k.category_id)}
                    data-testid={`plaza-subcat-${k.category_id}`}
                  >{k.name}</button>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </aside>
  );
}
